export function getPaymentSandboxHeaders(): Record<string, string> {
    const params = new URLSearchParams(window.location.search);
    const headers: Record<string, string> = {};
    const param = params.get('paymentGatewaySandboxPlease');
    if (param) {
        headers['x-dibs-PaymentGatewaySandboxPlease'] = param;
    }
    return headers;
}
